import { UserPayload } from "../models/SiteModel";
import { apiFetch } from "./fetchService";

const URLAPI = process.env.REACT_APP_BASE_URL;

export interface ProductosConfigListas {
  relacionListas: string;
  nombreListas: string;
  margenContado: string;
  margenMayorista: string;
  margenMinorista: string;
  decimalesEnCantidad: number;
  conMesas: boolean;
}

export async function fetchAppConfig(user: UserPayload): Promise<ProductosConfigListas | undefined> {
  const data = await apiFetch(user.token, `${URLAPI}/Config`);
  if (!data) {
    return undefined;
  }

  return {
    relacionListas: data.relacionListas ?? data.RelacionListas ?? "",
    nombreListas: data.nombreListas ?? data.NombreListas ?? "",
    margenContado: data.margenContado ?? data.MargenContado ?? "",
    margenMayorista: data.margenMayorista ?? data.MargenMayorista ?? "",
    margenMinorista: data.margenMinorista ?? data.MargenMinorista ?? "",
    decimalesEnCantidad: Number(data.decimalesEnCantidad ?? data.DecimalesEnCantidad ?? 2),
    conMesas: Boolean(data.conMesas ?? data.ConMesas ?? false)
  };
}
